export const COURSES = [
  {
    code: 'CS',
    name: 'Data Structures & Algorithms',
    tech: ['Java', 'Complexity Analysis'],
    bullets: ['Lists, trees, hash tables, graphs, and the trade-offs between them.', 'Asymptotic analysis and choosing the right structure for the problem.'],
  },
  {
    code: 'CS',
    name: 'Software Design',
    tech: ['OOP', 'Design Patterns', 'Agile'],
    bullets: ['Team-based development with version control, code review, and iterative delivery.', 'Object-oriented design principles applied to a semester-long project.'],
  },
  {
    code: 'CS',
    name: 'Computer Systems Programming',
    tech: ['C', 'Memory', 'Concurrency'],
    bullets: ['Low-level programming: memory management, processes, and system calls.', 'How the machine executes code and why performance behaves the way it does.'],
  },
  {
    code: 'CS',
    name: 'Algorithm Design & Analysis',
    tech: ['Dynamic Programming', 'Graphs', 'Proofs'],
    bullets: ['Greedy, divide-and-conquer, and dynamic programming techniques.', 'Correctness proofs and complexity bounds for algorithmic solutions.'],
  },
  {
    code: 'CS',
    name: 'Human–Computer Interaction',
    tech: ['UX Research', 'Prototyping', 'Usability Testing'],
    bullets: ['User-centered design process from needs assessment to prototype.', 'Usability evaluation methods applied to real interfaces.'],
  },
];
